<style>
.pop-select-dropdown-list .pop-tree li{
    padding-left: 16px;
}
.pop-select-dropdown-list .pop-tree li span.pop-tree-switcher, .pop-tree li span.pop-tree-iconEle{
    left:0;
    top: 1px;
}
</style>

<template>
    <div :class="classes" v-clickoutside="handleClose" v-el:xstore>
        <div
            :class="[prefixCls + '-selection']"
            v-el:reference
            @click="toggleMenu">
            <div :class="[PRE+'-tag']" v-for="(index,item) in filtered_selectedMultiple">
                <span :class="[PRE+'-tag-text']">{{ item.label }}</span>
                <p-icon type="ios-close-empty" @click.stop="removeTag(index,item.value)"></p-icon>
            </div>
            <span :class="[prefixCls + '-placeholder']" v-show="showPlaceholder && !filterable">{{ localePlaceholder }}</span>
            <span :class="[prefixCls + '-selected-value']" v-show="!showPlaceholder && !multiple && !filterable">{{ selectedSingle }}</span>
            <input
                type="text"
                v-if="filterable"
                v-model="query"
                :class="[prefixCls + '-input']"
                :placeholder="showPlaceholder ? localePlaceholder : ''"
                :style="inputStyle"
                @blur="handleBlur"
                @keydown="resetInputState"
                v-el:input>
            <p-icon type="ios-close" :class="[prefixCls + '-arrow']" v-show="showCloseIcon" @click.stop="clearSingleSelect"></p-icon>
            <p-icon type="ios-arrow-down" :class="[prefixCls + '-arrow']" v-if="!remote"></p-icon>
        </div>
            <Drop v-show="dropVisible" :placement="placement" v-ref:dropdown :transition="transitionName">
                <ul v-show="baseData[0]?!baseData[0].show:false" :class="[prefixCls + '-not-found']"><li>{{ localeNotFoundText }}</li></ul>
                <div v-show="(!notFound && !remote) || (remote && !loading && !notFound)" :class="[prefixCls + '-dropdown-list']" v-el:list>
                    <Tree :data="baseData" @on-check-change="setSelect" v-ref:tree></Tree>
                </div>
                <!-- <ul v-show="loading" :class="[prefixCls + '-loading']">{{ localeLoadingText }}</ul> -->
            </Drop>
        <div :class="[formPrefixCls + '-error-msg-tip']" v-if="validateMessage && showMessage">{{ validateMessage }}</div>
        <!-- {{baseData|json}} -->
    </div>
</template>
<script>
    import {oneOf,PRE} from '../../common/utils/assist';
    import Drop from './dropdown.vue';
    import directives from '../../common/directives/directives';
    import { getJSON } from '../common/utils';
    import Tree from './tree.vue';
    import Emitter from '../../common/mixins/emitter';
    import AsyncValidator from 'async-validator';
    const prefixCls = `${PRE}-select`;
    const formPrefixCls = `${PRE}-form-item`;
    export default {
        name: 'Store',
        mixins: [ Emitter ],
        components: { Drop,Tree },
        directives: { clickoutside:directives.clickoutside },
        ready(){
            let d=getJSON('https://shop.7fresh.com/shop/component/rest/index',"GET");
            d.done((data)=>{
                let tmp=[{
                    id:"",
                    code:'',
                    name:'',
                    show:true,
                    expand: true,
                    children:[]
                }];
                tmp[0].id=data.id||"";
                tmp[0].code=data.code;
                tmp[0].title=data.name;
                tmp[0].checked=false;
                for(let i in data.regions){
                    let row=data.regions[i];
                    tmp[0].children.push({
                        id:row.id||"",
                        show:true,
                        code:row.code,
                        expand: true,
                        title:row.name,
                        checked:false,
                        children:[]
                    });
                    for(let j in row.shops){
                        let row1=row.shops[j];
                        tmp[0].children[i].children.push({
                            id:row1.id,
                            show:true,
                            code:row1.id,
                            checked:false,
                            title:row1.name
                        });
                    }
                }

                this.baseData=tmp;
                this.$nextTick(function(){
                    this.checkTree();
                    this.$emit('on-data-loaded',this);
                });
            });
        },
        props: {
            model: {
                type: [Array,String],
                default () {
                    return [];
                }
            },
            label: {
                type: [String, Number, Array],
                default: ''
            },
            multiple: {
                type: Boolean,
                default: true
            },
            debug: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            clearable: {
                type: Boolean,
                default: true
            },
            placeholder: {
                type: String
            },
            filterable: {
                type: Boolean,
                default: true
            },
            filterMethod: {
                type: Function
            },
            remote: {
                type: Boolean,
                default: false
            },
            remoteMethod: {
                type: Function
            },
            loading: {
                type: Boolean,
                default: false
            },
            loadingText: {
                type: String
            },
            size: {
                validator (value) {
                    return oneOf(value, ['small', 'large', 'default']);
                }
            },
            labelInValue: {
                type: Boolean,
                default: false
            },
            notFoundText: {
                type: String
            },
            validateMessage:null,
            showMessage: {
                type: Boolean,
                default: true
            },
            rules: {
                type: Array,
                default() {
                    return [];
                }
            },
            placement: {
                validator (value) {
                    return oneOf(value, ['top', 'bottom']);
                },
                default: 'bottom'
            }
        },
        data () {
            return {
                baseData:[],
                PRE:PRE,
                prefixCls: prefixCls,
                formPrefixCls:formPrefixCls,
                visible: false,
                options: [],
                optionInstances: [],
                selectedSingle: '',    // label
                selectedMultiple: [],
                focusIndex: 0,
                query: '',
                lastQuery: '',
                selectToChangeQuery: false,    // when select an option, set this first and set query, because query is watching, it will emit event
                inputLength: 20,
                notFound: false,
                validateState: "",
                slotChangeDuration: false,    // if slot change duration and in multiple, set true and after slot change, set false
                value: [],
                currentLabel: this.label
            };
        },
        computed: {
            filtered_selectedMultiple(){
                return this.selectedMultiple && this.selectedMultiple.filter(item=>!item.remove);
            },
            classes () {
                return [
                    `${prefixCls}`,
                    {
                        [`${PRE}-form-item-error`]:this.validateState=='error',
//                      [`${PRE}-form-item-validating`]: this.validateState === 'validating',
                        [`${prefixCls}-visible`]: this.visible,
                        [`${prefixCls}-disabled`]: this.disabled,
                        [`${prefixCls}-multiple`]: this.multiple,
                        [`${prefixCls}-single`]: !this.multiple,
                        [`${prefixCls}-show-clear`]: this.showCloseIcon,
                        [`${prefixCls}-${this.size}`]: !!this.size
                    }
                ];
            },
            showPlaceholder () {
                let status = false;
                if (Array.isArray(this.filtered_selectedMultiple)) {
                    if (!this.filtered_selectedMultiple.length) {
                        status = true;
                    }
                } 
                return status;
            },
            showCloseIcon () {
                return this.clearable&&this.selectedMultiple.length;
            },
            inputStyle () {
                let style = {};
                if (this.multiple) {
                    if (this.showPlaceholder) {
                        style.width = '100%';
                    } else {
                        style.width = `${this.inputLength}px`;
                    }
                }
                return style;
            },
            localePlaceholder () {
                if (this.placeholder === undefined) {
                    return "";
                } else {
                    return this.placeholder;
                }
            },
            localeNotFoundText () {
                if (this.notFoundText === undefined) {
                    return "无匹配数据";
                } else {
                    return this.notFoundText;
                }
            },
            transitionName () {
                return this.placement === 'bottom' ? 'slide-up' : 'slide-down';
            },
            dropVisible () {
                let status = true;
                const options =  [];
                if (!this.loading && this.remote && this.query === '' && !options.length) status = false;
                return this.visible && status;
            }
        },
        methods: {
            checkTree(){
                if(this.model.length){
                    for(let i in this.model){
                        let row=this.model[i];
                        if(this.$els.xstore.querySelector("[data-id='"+row+"']")){
                            this.$els.xstore.querySelector("[data-id='"+row+"']").click();
                        }
                    }
                }
            },
            cannelSelect(ary){
                if(ary.length==0){
                    this.selectedMultiple=[];
                    this.baseData[0].checked=false;
                    for(let i in this.baseData[0].children){
                        let row= this.baseData[0].children[i];
                        row.checked=false;
                        for(let j in row.children){
                            let row1=row.children[j];
                            row1.checked=false;
                        }
                    }
                    this.model=[];
                }else{
                    this.$els.xstore.querySelector("[data-id='"+ary[0]+"']").click();
                }
            },
            fileterTree(val){
                const parsedQuery = val.replace(/(\^|\(|\)|\[|\]|\$|\*|\+|\.|\?|\\|\{|\}|\|)/g, '\\$1');
                this.baseData[0].show=false;
                for(let i in this.baseData[0].children){
                    let row= this.baseData[0].children[i];
                    row.show=false;
                    for(let j in row.children){
                        let row1=row.children[j];
                        row1.show=false;
                        let r=new RegExp(parsedQuery, 'i').test(!isNaN(val*1)?row1.code:row1.title);
                        if(r||val==''){
                            row1.show=true;
                            row.show=true;
                            this.baseData[0].show=true;
                            continue;
                        }
                    }
                }

            },
            setSelect(ary){
                this.selectedMultiple=[];
                let tmp=[];
                if(ary.length&&ary[0].code=="86"){
                    this.selectedMultiple.push({
                        value: ary[0].code,
                        label: ary[0].title,
                        children:ary[0].children||[],
                        remove:false
                    });
                    for(let i in ary){
                        let row=ary[i];
                        if(row.id){
                            tmp.push(row.id);
                        }
                    }
                }else{
                    for(let i=0;i<ary.length;i++){
                        let row=ary[i];
                        row.remove=false;
                    }
                    for(let i=0;i<ary.length;i++){
                        let row=ary[i];
                        if(row.children&&row.children.length){
                            let l=row.children.length;
                            for(let j=i+1;j<=i+l;j++){
                                ary[j].remove=true;
                            }
                        }
                        this.selectedMultiple.push({
                            value: row.code,
                            label: row.title,
                            children:row.children||[],
                            remove:row.remove
                        });
                        row.id?tmp.push(row.id):null;
                    }
                }
                this.$nextTick(function(){
                    this.$els.input.focus();
                    this.broadcast('Drop', 'on-update-popper');
                });
                this.model=tmp;
                this.$emit('on-check-change', this.baseData);
                // let tmp= [];
                //  tmp.push({
                //         id:this.baseData[0].id,
                //         code:this.baseData[0].code,
                //         title:this.baseData[0].title,
                //         checked:this.baseData[0].childrenCheckedStatus==1?false:true,
                //         children:[]
                //     });

                // for(let i in this.baseData[0].children){
                //     let row=this.baseData[0].children[i];
                //     tmp[0].children.push({
                //         id:row.id,
                //         code:row.code,
                //         title:row.title,
                //         checked:row.childrenCheckedStatus==1?false:true,
                //         children:[]
                //     });
                //     for(let j in row.children){
                //         let row1=row.children[j];
                //         tmp[0].children[i].children.push({
                //             id:row1.id,
                //             code:row1.code,
                //             title:row1.title,
                //             checked:row1.checked
                //         });
                //     }
                // }
                // this.value=tmp;
                // this.$emit("on-check-change",)
                this.validateFn();
            },
            toggleMenu () {
                if (this.disabled) {
                    return false;
                }
                this.visible = !this.visible;
            },
            hideMenu () {
                this.visible = false;
                this.focusIndex = 0;
            },
            // find option component
            clearSingleSelect () {
                if (this.showCloseIcon) {
                    this.cannelSelect([]);
                }
            },
            removeTag (index,id) {
                if(!id){
                    id=this.selectedMultiple[index].value;
                }
                if (this.disabled) {
                    return false;
                }
                this.cannelSelect(id=='86'?[]:[id]);
                if (this.filterable && this.visible) {
                    this.$els.input.focus();
                }

                this.broadcast('Drop', 'on-update-popper');
            },
            // to select option for single
            validateFn(callback){
                if(this.rules.length) {
                    var validator = new AsyncValidator({
                        "Store": this.rules
                    });
                    var tmp=this.model;
                    validator.validate({"Store": tmp}, {firstFields: true},errors => {
                        this.validateMessage=errors?errors[0].message:"";
                        this.validateState = !errors ? 'success' : 'error';
                        callback?callback(this.validateMessage):null;
                    });
                }else{
                    this.validateMessage="";
                    this.validateState ="";
                }
            },
            handleClose () {
                this.hideMenu();
            },
            handleKeydown (e) {
                if (this.visible) {
                    const keyCode = e.keyCode;
                    // Esc slide-up
                    if (keyCode === 27) {
                        e.preventDefault();
                        this.hideMenu();
                    }
                }
            },
            handleBlur () {
                setTimeout(() => {
                    const model = this.value;
                    if (this.multiple) {
                        this.query = '';
                    }
                }, 300);
            },
            resetInputState () {
                this.inputLength = this.$els.input.value.length * 12 + 20;
            },
            handleInputDelete () {
                if (this.multiple && this.selectedMultiple.length && this.query === '') {
                    this.removeTag(this.selectedMultiple.length - 1);
                }
            },
            // use when slot changed
            setQuery (query) {
                if (!this.filterable) return;
                this.query = query;
            },
        },
        compiled () {
            document.addEventListener('keydown', this.handleKeydown);
        },
        beforeDestroy () {
            document.removeEventListener('keydown', this.handleKeydown);
        },
        watch: {
            model (val) {
                this.value = val;
                if (val === ''||val.length==0) {
                    this.query = '';
                    this.clearSingleSelect();
                }
            },
            visible (val) {
                if (val) {
                    if (this.filterable) {
                        if (this.multiple) {
                            this.$els.input.focus();
                        } else {
                            this.$els.input.select();
                        }
                    }
                    this.broadcast('Drop', 'on-update-popper');
                } else {
                    if (this.filterable) {
                        this.$els.input.blur();
                        // #566 reset options visible
                    }
                    this.broadcast('Drop', 'on-destroy-popper');
                }
            },

            query (val) {
                if (!this.selectToChangeQuery) {
                    this.$emit('on-query-change', val);
                }

                this.selectToChangeQuery = false;
                this.broadcast('Drop', 'on-update-popper');
                this.fileterTree(val);
            }
        },
        events: {
            'on-form-reset' (field) {
                if(field){
                    this.validateMessage="";
                    this.validateState = "";
                }
                return false;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// xstore.vue?48f52859